<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <h5 class="t-white font-family-1 title-h5">
      {{ $t("new.conquest") }}
    </h5>
    <div
      class="d-flex-column select_honor_picker justify-start align-start gap-30"
    >
      <div class="d-flex-row space-between md-row-to-col select_honor_top">
        <div class="d-flex-row justify-start flex-6 gap-18">
          <img
            src="/images/icons/select_conquest.webp"
            alt="select_conquest"
            class="select_conquest"
            width="77"
            height="77"
          />
          <div class="d-flex-column justify-start align-start gap-0">
            <h6 class="bold-xxxl font-family-2 t-white">
              {{ $t("new.select_conquest") }}
            </h6>
            <p class="t-grey font-family-2 regular-m">
              {{ $t("new.select_desired_conquest") }}
            </p>
          </div>
        </div>
        <div class="flex-4 flex-md-10 justify-end">
          <ValueSetter
            v-model="numberOfConquest"
            :min="1000"
            :max="11000"
            :step="1"
          />
        </div>
      </div>
      <RangePircker
        :min="1000"
        :max="11000"
        v-model="numberOfConquest"
        :step="100"
        :steps="steps"
        :start-min="true"
      />
    </div>
  </div>
</template>

<script>
import ValueSetter from "../../commonpickers/ValueSetter.vue";
import RangePircker from "./RangePicker.vue";
export default {
  data() {
    return {
      numberOfConquest: 11000,
      steps: [
        {
          title: "1k",
        },
        {
          title: "2k",
        },
        {
          title: "3k",
        },
        {
          title: "4k",
        },
        {
          title: "5k",
        },
        {
          title: "6k",
        },
        {
          title: "7k",
        },
        {
          title: "8k",
        },
        {
          title: "9k",
        },
        {
          title: "10k",
        },
        {
          title: "11k",
        },
      ],
    };
  },
  components: {
    ValueSetter,
    RangePircker,
  },

  watch: {
    numberOfConquest() {
      this.checkoutStore.setDetails({
        desiredConquest: this.numberOfConquest,
      });
    },
  },

  setup() {
    const checkoutStore = useCheckoutStore();
    return {
      checkoutStore,
    };
  },
};
</script>
